import React, { type PropsWithChildren } from 'react';
import { Flex, Heading, Text, useBreakpointValue } from '@chakra-ui/react';

interface Props {
    subtitle?: string;
}

const ClientPageHeading = ({ children, subtitle }: PropsWithChildren<Props>) => {
    const isLargeScreen = useBreakpointValue({ base: false, lg: true });

    return (
        <Flex
            backgroundColor="brand.primary"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            padding="16px"
            boxSizing="border-box"
            height="100%"
            width="100%"
        >
            <Heading
                as="h1"
                letterSpacing={isLargeScreen ? '6px' : '3px'}
                fontSize={isLargeScreen ? '3xl' : '2xl'}
                color="background"
                margin={0}
                size={isLargeScreen ? '3xl' : '2xl'}
                textAlign="center"
                textShadow="0px 5px 9px rgba(0, 0, 0, 0.25)"
            >
                {children}
            </Heading>
            {subtitle && (
                <Text textAlign="center" fontSize="lg" color="background" fontWeight="normal">
                    {subtitle}
                </Text>
            )}
        </Flex>
    );
};

export default ClientPageHeading;
